"use client";

import { useOnClickOutside } from "@/app/hooks/useOnClickOutside";
import clsx from "clsx";
import { Dispatch, SetStateAction, useState } from "react";
import { DropdownButton } from "../DropdownButton";
import { TravellersDropdownWithCabinClass } from "./TravellersDropdownWithCabinClass";
import type { SearchValues } from "@/types/flights";

type Props = {
  valueAsLabel?: string;
  className?: string;
  isFullScreenModal?: boolean;
  values: SearchValues;
  setValues: Dispatch<SetStateAction<SearchValues>>;
};

export const TravellersWithCabinClass = ({
  className,
  valueAsLabel,
  isFullScreenModal = false,
  setValues,
  values,
}: Props) => {
  const [isOpen, setOpen] = useState(false);
  const ref = useOnClickOutside<HTMLDivElement>(() => setOpen(false));

  return (
    <div className={clsx("relative inline-block", className)} ref={ref}>
      <DropdownButton onClick={() => setOpen((prev) => !prev)}>
        {valueAsLabel}
      </DropdownButton>

      {isOpen && (
        <TravellersDropdownWithCabinClass
          isFullScreenModal={isFullScreenModal}
          onClose={() => setOpen(false)}
          values={values}
          setValues={setValues}
        />
      )}
    </div>
  );
};
